module.exports = "/_next/static/images/RichCustomerProfiles@2x-73089f6c1000433e95ce99888fe4d16d.png";